var map = {
	"./4g-0.png": "hJK8",
	"./4g-1.png": "7GqY",
	"./4g-2.png": "PLuP",
	"./4g-3.png": "RVQt",
	"./4g-4.png": "+SVt",
	"./4g-5.png": "6WmH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XOQy";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon ^\.\/4g\-.*\.png$
// module id = XOQy
// module chunks = 1